<template>
<div class="tingshen-user">
    <div class="title-jc">
        <div>案件信息</div>
    </div>
    <div class="tingshen-user-in">
        <el-row :gutter="24">
            <el-col :span="12">
                <div class="bg-purple">案由：{{mediationMeetingRes.causeName}}</div>
            </el-col>
            <el-col :span="12">
                <div class="bg-purple">案号：{{mediationMeetingRes.name}}</div>
            </el-col>
        </el-row>
        <el-row :gutter="24">
            <el-col :span="12">
                <div class="bg-purple">仲裁员：{{mediationMeetingRes.zcy}}</div>
            </el-col>
            <el-col :span="12">
                <div class="bg-purple">书记员：{{mediationMeetingRes.sjy}}</div>
            </el-col>
        </el-row>

    </div>
    <!-- 申请人信息 -->
    <div class="title-jc">案件申请人信息</div>
    <template v-if="dsrList.filter(n => n.type === 'person').length > 0">
        <el-table :data="dsrList.filter(n => n.type === 'person')" border style="width: 100%; margin-top:10px;">
            <el-table-column prop="ssdw" label="诉讼地位">
            </el-table-column>
            <el-table-column prop="userName" label="姓名">
            </el-table-column>
            <el-table-column prop="sex" label="性别">
            </el-table-column>
            <el-table-column prop="minority" label="民族">
            </el-table-column>
            <el-table-column prop="birth" label="出生年月日">
            </el-table-column>
            <el-table-column prop="mobilePhone" label="手机号">
                <template slot-scope="scope">
                    <div>{{scope.row.mobilePhone}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.mobilePhone,'phone','手机号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column prop="idCard" label="身份证号" width="170px">
                <template slot-scope="scope">
                    <div>{{scope.row.idCard}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.idCard,'idCard','身份证号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column prop="address" label="身份证地址">
            </el-table-column>
            <el-table-column prop="userName" label="笔录中名称" v-if="spaceType==0">
                <template slot-scope="scope">
                    <div>{{scope.row.recordName}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.recordName,'record','笔录中名称')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column label="是否允许上传证据" v-if="isWorker && !isManage && spaceType==0">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.canUpload"  active-color="#3C93F7" @change="changeSwitch($event,scope.row)"></el-switch>
                </template>
            </el-table-column>
        </el-table>
    </template>
    <template v-if="applicantList.filter(n => n.type !== 'person').length > 0">
        <el-table :data="applicantList.filter(n => n.type !== 'person')" border style="width: 100%; margin-top:10px;">
            <el-table-column prop="conName" label="单位名称">
            </el-table-column>
            <el-table-column prop="legalPerson" label="法定代表人">
            </el-table-column>
            <el-table-column prop="address" label="地址">
            </el-table-column>
        </el-table>
    </template>
    <!-- 被申请人信息 -->
     <div class="title-jc">案件被申请人信息</div>
    <template v-if="respondentList.filter(n => n.type === 'person').length > 0">
        <el-table :data="respondentList.filter(n => n.type === 'person')" border style="width: 100%; margin-top:10px;">
            <el-table-column prop="userName" label="姓名">
            </el-table-column>
            <el-table-column prop="sex" label="性别">
            </el-table-column>
            <el-table-column prop="minority" label="民族">
            </el-table-column>
            <el-table-column prop="birth" label="出生年月日">
            </el-table-column>
            <el-table-column prop="mobilePhone" label="手机号">
                <template slot-scope="scope">
                    <div>{{scope.row.mobilePhone}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.mobilePhone,'phone','手机号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column prop="idCard" label="身份证号" width="170px">
                <template slot-scope="scope">
                    <div>{{scope.row.idCard}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.idCard,'idCard','证件号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column prop="address" label="身份证地址">
            </el-table-column>
        </el-table>
    </template>
    <template v-if="respondentList.filter(n => n.type !== 'person').length > 0">
        <el-table :data="respondentList.filter(n => n.type !== 'person')" border style="width: 100%; margin-top:10px;">
            <el-table-column prop="userName" label="单位名称">
            </el-table-column>
            <el-table-column prop="legalPerson" label="法定代表人">
            </el-table-column>
            <el-table-column prop="address" label="地址">
            </el-table-column>
        </el-table>
    </template>
    <!-- 代理人信息-->
    <div class="title-jc">代理人信息</div>
    <template v-if="agentList.length > 0">
        <el-table :data="agentList" border style="width: 100%; margin-top:10px;">
            <el-table-column prop="agentPosition" label="代理类型">
            </el-table-column>
            <el-table-column  label="代理对象">
                <template slot-scope="scope">
                    <span v-for="(item,index) in scope.row.agentPersonInfos" :key="'agent'+index">{{item.company ? item.company : item.userName}}{{index == scope.row.agentPersonInfos.length - 1 ? '' : ','}}</span>
                    <el-button v-if="isWorker && !isManage && scope.row.agentPersonInfos.length" @click="modifyAgentInfoEvent(scope.row)" :disabled="isClosed" type="primary" size="small" style="border-radius:4px;">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="agentAddress" label="所在单位">
            </el-table-column>
            <el-table-column prop="userName" label="姓名">
            </el-table-column>
            <el-table-column prop="agentIdCardType" label="证件类型">
            </el-table-column>

            <el-table-column prop="mobilePhone" label="手机号">
                <template slot-scope="scope">
                    <div>{{scope.row.mobilePhone}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.mobilePhone,'phone','手机号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column prop="idCard" label="证件号" width="170px">
                <template slot-scope="scope">
                    <div>{{scope.row.idCard}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.idCard,'idCard','证件号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column label="笔录中名称" v-if="spaceType==0">
                <template slot-scope="scope">
                    <div>{{scope.row.recordName}}</div>
                    <el-button v-if="isWorker && !isManage" @click="modifyRecordName(scope.row,scope.row.recordName,'record','笔录中名称')" :disabled="isClosed" type="primary" size="small" style="border-radius:4px;">修改</el-button>
                </template>
            </el-table-column>
            <el-table-column label="是否允许上传证据" v-if="isWorker && !isManage && spaceType==0">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.canUpload"  active-color="#3C93F7" @change="changeSwitch($event,scope.row)"></el-switch>
                </template>
            </el-table-column>
        </el-table>
    </template>

    <div class="title-jc" v-if="otherList && otherList.length">案件其他人信息</div>
    <template v-if="otherList.filter(n => n.type === 'person').length > 0">
        <el-table :data="otherList.filter(n => n.type === 'person')" border style="width: 100%; margin-top:10px;">
            <el-table-column prop="ssdw" label="诉讼地位">
            </el-table-column>
            <el-table-column prop="userName" label="姓名">
            </el-table-column>
            <el-table-column prop="sex" label="性别">
            </el-table-column>
            <el-table-column prop="minority" label="民族">
            </el-table-column>
            <el-table-column prop="birth" label="出生年月日">
            </el-table-column>
            <el-table-column prop="mobilePhone" label="手机号">
                <template slot-scope="scope">
                    <div>{{scope.row.mobilePhone}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.mobilePhone,'phone','手机号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column prop="idCard" label="身份证号" width="170px">
                <template slot-scope="scope">
                    <div>{{scope.row.idCard}}</div>
                    <el-button v-if="isWorker && !isManage" :disabled="isClosed" @click="modifyRecordName(scope.row,scope.row.idCard,'idCard','身份证号')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column prop="address" label="身份证地址">
            </el-table-column>
            <el-table-column prop="userName" label="笔录中名称" v-if="spaceType==0">
                <template slot-scope="scope">
                    <div>{{scope.row.recordName}}</div>
                    <el-button v-if="isWorker && !isManage" disabled @click="modifyRecordName(scope.row,scope.row.recordName,'record','笔录中名称')" type="primary" size="small" style=" border-radius:4px;">修改</el-button>
                    <!-- <div>修改</div> -->
                </template>
            </el-table-column>
            <el-table-column label="是否允许上传证据" v-if="isWorker && !isManage && spaceType==0">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.canUpload" disabled active-color="#3C93F7" @change="changeSwitch($event,scope.row)"></el-switch>
                </template>
            </el-table-column>
        </el-table>
    </template>

    <!-- 仲裁请求-->
    <div class="title-jc">仲裁请求</div>
    <template v-if="claimForArbitrationList && claimForArbitrationList.length > 0">
        <el-table :data="claimForArbitrationList" :show-header="false" border style="width: 100%; margin-top:10px; margin-bottom:30px;">
            <el-table-column prop="userName" width="300">
            </el-table-column>
            <el-table-column prop="claimForArbitration">
                <template slot-scope="scope">
                    <div class="arbitration-request">{{scope.row.claimForArbitration}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="operate" v-if="isWorker && !isClosed && !isManage" width="100">
                <template slot-scope="scope">
                    <el-button  @click="showModifyRequestDialog(scope.row)" type="primary" size="small" style="border-radius:4px;">修改</el-button>
                </template>
            </el-table-column>
        </el-table>
    </template>

    <el-dialog :visible.sync="modifyRequestDialog" width="800px" title="修改仲裁请求" :destroy-on-close="true" :close-on-click-modal="false" center>
        <el-form :model="mdForm" ref="mdForm" label-width="100px" class="" label-position="right">
            <el-form-item label="原请求">
                <el-input type="textarea" :rows="4" disabled v-model="requestForm.orginRequest" mut></el-input>
            </el-form-item>
            <el-form-item label="新请求">
                <el-input type="textarea" :rows="6" class="yqInput" v-model="requestForm.modifiedRequest"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" style="border-radius:4px;width:120px;" @click="modifyRequestHandle">确定</el-button>
        </div>
    </el-dialog>
    <el-dialog :visible.sync="showModifyRecordDialog" width="30%" :title="updateTitle" :destroy-on-close="true" :close-on-click-modal="false" center>
        <el-form :model="mdForm" ref="mdForm" label-width="100px" class="demo-ruleForm" label-position="right">
            <el-form-item :label="oldName">
                <el-input :disabled="true" v-model="mdForm.orginName"></el-input>
            </el-form-item>
            <el-form-item :label="newName">
                <el-input class="yqInput" v-model="mdForm.modifiedName"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" style="border-radius:4px;width:120px;" @click="updateInfo">确定</el-button>
        </div>
    </el-dialog>
    <el-dialog :visible.sync="showModifyAgentDialog" width="60%" title="修改代理对象" :destroy-on-close="true" :close-on-click-modal="false" center>
        <el-form :model="currentAgentRow"  label-width="100px" class="demo-ruleForm" label-position="right">
            <div class="agentItem" v-for="(item,index) in currentAgentRow.agentPersonInfos" :key="'modify'+index">
                <el-row v-if="item.lx == 2">
                    <el-col :span="20">
                        <el-form-item label="公司名称">
                           <el-input class="yqInput" v-model="item.company"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="20">
                        <el-form-item label="地址">
                            <el-input class="yqInput" v-model="item.address"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="法人">
                            <el-input class="yqInput" v-model="item.legalPerson"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-else>
                    <el-col :span="12">
                        <el-form-item label="姓名">
                           <el-input class="yqInput" v-model="item.userName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="民族">
                            <el-input class="yqInput" v-model="item.minority"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别">
                            <el-input class="yqInput" v-model="item.sex"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号" width="170px">
                            <el-input class="yqInput" v-model="item.idCard"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="20">
                        <el-form-item label="地址">
                            <el-input class="yqInput" v-model="item.address"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <i @click="deleteAgent(index, currentAgentRow.agentPersonInfos.length)" class="el-icon-delete"></i>
            </div>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" style="border-radius:4px;width:120px;" @click="modifyAgentHandle">确定</el-button>
            <el-button type="primary" style="border-radius:4px;width:120px;" @click="cancleAgentHandle">取消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {
    caseInfoApi,
    updateRecordName,
    updateUserCardAndPhone,
    updateRequestItem,
    modifyAgentInfo,
    addCaseMeeting,
    updateUserCanUpload
} from "@/api/casespace.js";
import { getStore, setStore, checkSpecialCharacter} from '@/utils/utils.js'
import {ERR_OK} from "../../../api/reConfig";
import {isManageRole} from "../../../utils/utils";

const Base64 = require('js-base64').Base64

export default {
    data() {
        return {
            spaceType: 0, // 默认0  0异步庭审   1异步调解   2在线送达
            // 申请人集合
            applicantList: [],
            // 被申请人集合
            respondentList: [],
            // 代理人集合
            agentList: [],
            otherList: [],
            // 仲裁请求集合
            claimForArbitrationList: [],
            // 案件基本信息对象
            mediationMeetingRes: {
                causeName: '',
                name: '',
                zcy: '',
                sjy: ''
            },
            dsrList: [],
            showModifyRecordDialog: false,
            modifyRequestDialog: false,
            requestForm: {
                orginRequest: '',
                modifiedRequest: '',
                row: null,
            },
            mdForm: {
                orginName: '',
                modifiedName: '',
                row: {}
            },
            isWorker: false,
            isManage: false,
            isClosed: localStorage.getItem('CloseState') == 'true' ? true : false,
            showModifyAgentDialog:false,
            currentAgentRow:{},
            switch1: true,
            oldName: '',
            newName: '',
            updateTitle: '',
            updateType: 'record'
        };
    },
    created() {
        let loginInfo = JSON.parse(getStore('loginInfo'))
        if( loginInfo ){
            this.isWorker = loginInfo.personType === 'STAFF'
            this.isManage = isManageRole(loginInfo.userRoles)
        }
        if (this.$route.query.spaceType) {
            this.spaceType = Number(this.$route.query.spaceType)
        }
        this.getData()
    },

    methods: {
        getData() {
            let loginInfo = JSON.parse(getStore('loginInfo'))
            let now_userId = loginInfo.memberId

            let params = {
                meetingId: this.$route.query.meetingid
            };
            caseInfoApi(params).then((res) => {
                    let data = res.data.data;
                    this.applicantList = data.applicantList;
                    this.applicantList.map(n => {
                        n.ssdw = '申请人'
                    })
                    this.respondentList = data.respondentList;
                    this.respondentList.map(n => {
                        n.ssdw = '被申请人'
                    })
                    this.dsrList = [...this.applicantList, ...this.respondentList]
                    this.agentList = data.agentList;
                    this.otherList = data.otherList;
                    this.otherList.map(n => {
                        n.ssdw = '其他人'
                    })

                    this.claimForArbitrationList = data.claimForArbitrationList2 || data.claimForArbitrationList;
                    this.mediationMeetingRes = data.mediationMeetingRes;

                    let find = false
                    data.applicantList.some(n => {
                        if (n.userId == now_userId) {
                            find = true
                            setStore('canUpload', n.canUpload ? '1' : '0');
                            return true
                        }
                    })
                    if (find == false) {
                        data.respondentList.some(n => {
                            if (n.userId == now_userId) {
                                find = true
                                setStore('canUpload', n.canUpload ? '1' : '0');
                                return true
                            }
                        })
                    }
                    if (find == false) {
                        data.agentList.some(n => {
                            if (n.userId == now_userId) {
                                setStore('canUpload', n.canUpload ? '1' : '0');
                                return true
                            }
                        })
                    }

                    console.log('result::', this.dsrList);
                }).catch((err) => {});
        },
        modifyAgentInfoEvent(row){
            //深拷贝一个对象 防止数据污染
            let currentRow = JSON.parse(JSON.stringify(row))
            this.showModifyAgentDialog = true
            this.currentAgentRow = currentRow
            this.currentAgentRow.agentPersonInfos.map(item => {
                if(!item.company){
                    item.lx = 1
                }else{
                    item.lx = 2
                }
            })
            console.log('---修改代理对象----', this.currentAgentRow)
        },
        deleteAgent(index, count){
            this.$confirm(
                count>1 ?'是否确认删除该代理对象?' : '删除后不可新增，是否确认删除该代理对象?',
                    "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        customClass: "close-mediate-room",
                        dangerouslyUseHTMLString: true,
                        center: true,
                    }
                ).then(() => {
                     this.currentAgentRow.agentPersonInfos.splice(index,1)
                      console.log('删除对象----',this.currentAgentRow,this.agentList)
                }).catch( () => {})

        },
        modifyAgentHandle(){
            let params = {
                personId:this.currentAgentRow.personId,
                userId:this.currentAgentRow.userId,
                agentPersonInfos:this.currentAgentRow.agentPersonInfos
            }
            // modifyAgentInfo(params).then(res => {

            // }).catch(err => {

            // })
            modifyAgentInfo(params).then(res => {
                console.log('res----', res)
                this.getData()
                this.showModifyAgentDialog = false
            }).catch(err => {
                this.showModifyAgentDialog = false
                this.$message({
                    type: 'error',
                    message: '修改代理对象失败!'
                })
            })
        },
        cancleAgentHandle(){
            this.showModifyAgentDialog = false
        },
        showModifyRequestDialog(row) {
            console.log('---修改仲裁请求----', row)
            this.requestForm.orginRequest = row.claimForArbitration
            this.requestForm.modifiedRequest = ''
            this.requestForm.row = row
            this.modifyRequestDialog = true
        },
        modifyRecordName(row,val,type,title) {
            console.log('---修改笔录中名字----', row)
            const nametitle = {
                record: [ '笔录旧名称','笔录新名称'],
                phone: ['旧号码', '新号码'],
                idCard: ['旧身份证号', '新身份证号'],
            }
            const [oldName, newName] = nametitle[type]
            this.updateType = type
            this.oldName = oldName
            this.newName = newName
            this.mdForm.orginName = val
            this.mdForm.modifiedName = ''
            this.mdForm.row = row
            this.updateTitle = `修改${title}`
            this.showModifyRecordDialog = true
        },
        modifyRequestHandle(){
            if (!this.requestForm.modifiedRequest.trim()){
                this.$message({
                    type: 'error',
                    message: '请输入新仲裁请求!'
                })
                return
            }
            if(checkSpecialCharacter(this.requestForm.modifiedRequest)){
                this.$message({
                    type: 'error',
                    message: '新仲裁请求有特殊符号!'
                })
                return
            }

            let param = this.requestForm.row
            param.claimForArbitration = this.requestForm.modifiedRequest
            param.meetingId = this.$route.query.meetingid
            updateRequestItem(param).then(res => {
                if (res.data.code == 1000) {
                    this.getData()
                    this.modifyRequestDialog = false
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }

            }).catch(err => {
                this.modifyRequestDialog = false
                this.$message({
                    type: 'error',
                    message: '修改仲裁请求失败!'
                })
            })
        },
        updateInfo() {
            if (this.updateType === 'record') {
                this.modifyNameHandle()
            } else {
                if (!this.mdForm.modifiedName.trim()){
                    this.$message({
                        type: 'error',
                        message: '修改项不能为空!'
                    })
                    return
                }
                let params = {
                    personId: this.mdForm.row.personId,
                    userId: this.mdForm.row.userId,
                }
                if (this.updateType === 'phone') {
                    params.mobilePhone = this.mdForm.modifiedName
                }
                if (this.updateType === 'idCard') {
                    params.idCard = this.mdForm.modifiedName
                }
                updateUserCardAndPhone(params).then(res => {
                    console.log('res----', res)
                    this.getData()
                    this.$message(res.data.message ? res.data.message : '修改成功')
                    this.showModifyRecordDialog = false
                }).catch(err => {
                    this.showModifyRecordDialog = false
                    this.$message({
                        type: 'error',
                        message: '修改失败!'
                    })
                })
            }
        },
        modifyNameHandle(){
            if (!this.mdForm.modifiedName.trim()){
                this.$message({
                    type: 'error',
                    message: '笔录中新名称为空!'
                })
                return
            }
            let mdName = this.mdForm.modifiedName
            if(mdName.indexOf('&') != -1 || mdName.indexOf('$') != -1 || mdName.indexOf('#') != -1){
                this.$message({
                    type: 'error',
                    message: '笔录中新名称有特殊符号!'
                })
                return
            }
            let params = {
                personId: this.mdForm.row.personId,
                userId: this.mdForm.row.userId,
                recordName: this.mdForm.modifiedName
            }
            updateRecordName(params).then(res => {
                console.log('res----', res)
                this.getData()
                this.showModifyRecordDialog = false
            }).catch(err => {
                this.showModifyRecordDialog = false
                this.$message({
                    type: 'error',
                    message: '修改笔录新名称失败!'
                })
            })
        },
        changeSwitch(e, obj){
            console.log(e)
            console.log(obj)
            let params = {
                personId: obj.personId,
                userId: obj.userId,
                canUpload: e
            }
            updateUserCanUpload(params).then(res => {

            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: '设置失败!'
                })
            })
        },
    }
}
</script>

<style lang="scss">
 .tingshen-user {
    font-size: 14px;
    padding: 0 8%;

    .title-jc {
        position: relative;
        padding: 30px 15px;
        font-size: 16px;
    }

    .title-jc:before {
        content: "";
        position: absolute;
        display: block;
        left: 4px;
        top: 33px;
        width: 4px;
        height: 0;
        border-top: 16px solid #0092ff;
    }

    .tingshen-user-in {
        .bg-purple {
            padding: 20px;
        }

    }

    .attendant-number {
        margin-left: 20px;

        .bg-purple {
            padding: 20px 0;
        }
    }
  }
  .agentItem{
      display: flex;
      border-bottom: 1px solid #f3f3f3;
      padding-top: 10px;
      i{
          font-size: 32px;
          color:#0083c8;
          margin-left: 4px;
      }
  }
    .make_item {
        display: flex;
        line-height: 40px;
        margin-bottom: 20px;
    }
    .arbitration-request {
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
    }
</style>
